export const darkTheme = {
  "img-bg": `url("../assets/bg-desktop-dark.jpg")`,
  "img-mobile-bg": `url("../assets/bg-mobile-dark.jpg")`,
  "clr-primary": "hsl(0, 0%, 98%)",
  "clr-page-bg": "hsl(235, 21%, 11%)",
  "clr-card-bg": "hsl(235, 24%, 19%)",
  "clr-gb-1": "hsl(236, 33%, 92%)",
  "clr-gb-2": "hsl(234, 39%, 75%)",
  "clr-gb-3": "hsl(234, 11%, 52%)",
  "clr-gb-4": "hsl(237, 12%, 36%)",
  "clr-gb-5": "hsl(233, 14%, 35%)",
  "clr-gb-6": "hsl(235, 19%, 24%)",
};

export const lightTheme = {
  "img-bg": `url("../assets/bg-desktop-light.jpg")`,
  "img-mobile-bg": `url("../assets/bg-mobile-light.jpg")`,
  "clr-primary": "hsl(243, 12%, 30%)",
  "clr-page-bg": "hsl(0, 0%, 98%)",
  "clr-card-bg": "hsl(0, 0%, 100%)",
  "clr-gb-1": "hsl(240, 8%, 24%)",
  "clr-gb-2": "hsl(243, 12%, 30%)",
  "clr-gb-3": "hsl(252, 6%, 83%)",
  "clr-gb-4": "hsl(237, 10%, 64%)",
  "clr-gb-5": "hsl(252, 9%, 73%)",
  "clr-gb-6": "hsl(252, 21%, 94%)",
};
